// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2kAmc","clickable":"Table_clickable__2J0ig","easyTable":"Table_easyTable__2Iw-0"};